import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './core/components/login/login.component';
import {NotFoundComponent} from './core/components/not-found/not-found.component';
import {DashboardRoutingModule} from './dashboard/dashboard-routing.module';
import {AuthGuard} from './core/guards/auth.guard';
import {AdminRoutingModule} from './admin/admin-routing.module';
import {KfDataEntryRoutingModule} from './kf-data-entry/kf-data-entry-routing.module';
import {KfReportingRoutingModule} from './kf-reporting/kf-reporting-routing.module';
import {IntelligenceReportingRoutingModule} from './intelligence-reporting/intelligence-reporting-routing.module';
import {KfChartsRoutingModule} from './kf-charts/kf-charts-routing.module';
import {IntelligenceDataEntryRoutingModule} from './intelligence-data-entry/intelligence-data-entry-routing.module';
import {IntelligenceRoutingModule} from './intelligence/intelligence-routing.module';
import {NotAllowedComponent} from './core/components/not-allowed/not-allowed.component';

const routes: Routes = [
  // {path: '', component: AppComponent, canActivate: [AuthGuard], pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  {path: 'forbidden', component: NotAllowedComponent},
  {path: '**', component: NotFoundComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    DashboardRoutingModule,
    AdminRoutingModule,
    IntelligenceReportingRoutingModule,
    KfDataEntryRoutingModule,
    KfReportingRoutingModule,
    KfChartsRoutingModule,
    IntelligenceRoutingModule,
    IntelligenceDataEntryRoutingModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
